import * as XLSX from 'xlsx';
import type { SyncFinding } from '../api';

export interface FindingExportRow {
  id: string;
  severity: string;
  category: string;
  review_engine: string;
  title: string;
  description: string;
  suggestion: string;
  status: 'resolved' | 'unresolved';
  auto_fixable: 'yes' | 'no';
  file_path: string;
  created_at: string;
  resolved_at: string;
}

function toRow(f: SyncFinding): FindingExportRow {
  return {
    id: f.id,
    severity: f.severity,
    category: f.category,
    review_engine: f.review_engine ?? '',
    title: f.title,
    description: f.description,
    suggestion: f.suggestion ?? '',
    status: f.resolved ? 'resolved' : 'unresolved',
    auto_fixable: f.auto_fixable ? 'yes' : 'no',
    file_path: f.file_path ?? '',
    created_at: f.created_at,
    resolved_at: f.resolved_at ?? '',
  };
}

export function exportFindingsToExcel(
  findings: SyncFinding[],
  filename: string = `ocnexus-findings-${new Date().toISOString().split('T')[0]}.xlsx`,
): void {
  const rows: FindingExportRow[] = findings.map((f: SyncFinding) => toRow(f));
  const ws = XLSX.utils.json_to_sheet(rows);

  const headers: Array<keyof FindingExportRow> = rows.length > 0
    ? (Object.keys(rows[0]) as Array<keyof FindingExportRow>)
    : ['id', 'severity', 'category', 'review_engine', 'title', 'description', 'suggestion', 'status', 'auto_fixable', 'file_path', 'created_at', 'resolved_at'];

  ws['!cols'] = headers.map((key: keyof FindingExportRow) => {
    const maxLen = Math.max(
      String(key).length,
      ...rows.map((r: FindingExportRow) => String(r[key] ?? '').length),
    );
    return { wch: Math.min(maxLen + 2, 80) };
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Findings');
  XLSX.writeFile(wb, filename);
}
